import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "question-detail",
  "talqs-app": ""
}
const _hoisted_2 = { class: "m-dot-que-section" }
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "m-section-content question-title",
        ref: "refQueTileWrap",
        id: `questionTitle_${$props.questionData.queId}_${$props.questionIndex}`
      }, null, 8, _hoisted_3)
    ])
  ]))
}